module.exports = __webpack_public_path__ + "static/media/11.e6299b29.jpg";